import { Component } from '@angular/core';
import { HierarchyTab } from '@ov-suite/ui';
import { OvAutoService } from '@ov-suite/services';
import { Router } from '@angular/router';
import { VehicleTemplate } from '@ov-suite/models-warehouse';
import { TableTopTabMenuItem } from '../../../components/table-top-tab-menu/table-top-tab-menu.model';

@Component({
  selector: 'ov-suite-vehicle-template-list',
  templateUrl: './vehicle-template-list.component.html',
  styleUrls: ['./vehicle-template-list.component.scss'],
})
export class VehicleTemplateListComponent {
  formClass = VehicleTemplate;

  filter: Record<string, unknown[]>;

  currentData: VehicleTemplate[] = [];

  tabs: HierarchyTab[] = [
    { title: 'Picking Waves', path: '/waves' },
    { title: 'Vehicles', path: '/vehicles' },
    { title: 'Routes', path: '/master-route' },
  ];

  tableTabs: TableTopTabMenuItem[] = [
    { title: 'All', path: '/vehicles', key: 'all' },
    { title: 'Templates', path: '/vehicles/templates', key: 'templates' },
   // { title: 'Archived', path: '/vehicles/archived', key: 'archived' },
    { title: 'Exceptions', path: '/vehicles/exception', key: 'exception' },
  ];

  constructor(public readonly ovAutoService: OvAutoService, private readonly route: Router) {}

  onTabClick(key) {
    const tab = this.tableTabs.find(t => t.key === key);
    this.route.navigate([tab.path]);
  }
}
